

const Icon = ({ galleryIcon, type }) => {
    let iconClass = "";
    let iconName = "";

    switch (type) {
        case "audio":
            iconClass = "music_icon audio_icon";
            iconName = "fas fa-music";
            break;
        case "video":
            iconClass = "music_icon video_icon";
            iconName = "fas fa-play";
            break;
        case "content":
            iconClass = "contnet-svgImage";
            iconName = "fas fa-newspaper";
            break;
        case "pdf":
            iconClass = "music_icon video_icon";
            iconName = "fas fa-file-pdf";
            break;
        default:
            iconClass = "music_icon audio_icon";
            iconName = "fas fa-link";
    }

    return galleryIcon && <div className={iconClass}><i className={iconName}></i></div>;
}

export default Icon;
